module.exports = __webpack_public_path__ + "static/media/img4.f451aa67.jpg";